import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let dataAnimation = document.querySelectorAll("[data-animation]");

dataAnimation.forEach((animation) => {
  let dataDelay = "";
  let dataTranslate = "";
  let dataRotate = "";
  let dataScale = "";

  //delay
  if (animation.hasAttribute("data-animation-delay")) {
    dataDelay = animation.getAttribute("data-animation-delay");
  } else {
    dataDelay = 0.2;
  }

  //translate
  if (animation.hasAttribute("data-animation-translate")) {
    dataTranslate = animation.getAttribute("data-animation-translate");
  } else {
    dataTranslate = undefined;
  }

  //scale
  if (animation.hasAttribute("data-animation-scale")) {
    dataScale = animation.getAttribute("data-animation-scale");
  } else {
    dataScale = undefined;
  }

  //rotate
  if (animation.hasAttribute("data-animation-rotate")) {
    dataRotate = animation.getAttribute("data-animation-rotate");
  } else {
    dataRotate = undefined;
  }

  gsap.from(animation, {

    opacity: 0,
    delay: dataDelay,
    translate: dataTranslate,
    rotate: dataRotate,
    scale: dataScale,

    scrollTrigger: {
      trigger: animation,
      markers: false,
      start: "top bottom-=5%",
      end: "bottom+=10% top+=5%",
      toggleActions: "play reverse play reverse",
    },
  });
});




let dataAnimationProspective = document.querySelectorAll("[data-animation-prospective]");

dataAnimationProspective.forEach((prospective) => {

gsap.from(prospective, {
  
    transformStyle: "preserve-3d",
    rotateX: "-4deg",
    y: "20%",
    scale: 1.1,

    scrollTrigger: {
      trigger: prospective,
      markers: false,
      start: "top bottom",
      end: "bottom+=10% top+=5%",
      toggleActions: "play reverse play reverse",
    },
  });
});



gsap.set('.splinter', {
  xPercent:-50
});
var rotate = gsap.timeline({
  scrollTrigger:{
    trigger: '.with-splinter',
    pin: true,
    scrub:2,
    start: 'top+=50% top+=50%',
    end:'bottom bottom',
  }
})
.to('.splinter', {
  rotation:30,
  duration:1,
  ease:'none',
})